/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { Breadcrumbs, BreadcrumbsProps } from '@squiz/sds';
import { DxpScreen } from 'apps/console-core/src/Components/DxpScreen/DxpScreen';
import { DXP_SCREEN_LAYOUT_STANDARD } from 'apps/console-core/src/Components/DxpScreen/types/DxpScreenLayout.types';
import { DXP_SCREEN_STRUCTURE_WIDE } from 'apps/console-core/src/Components/DxpScreen/types/DxpScreenStructure.types';
import { useCapabilityBreadcrumbs } from 'apps/console-core/src/Hooks/UseCapabilityBreadcrumbs/UseCapabilityBreadcrumbs';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { MONITORING_DATA_IDS } from '../../Constants/DataIDs.constants';
import { MONITORING_STRINGS } from '../../Constants/Strings.constants';
import { MonitoringDashboardContent } from './elements/MonitoringDashboardContent/MonitoringDashboardContent';

export const MonitoringDashboard = (): JSX.Element => {
  const { t } = useTranslation();
  const labels = useMemo(() => {
    return {
      heading: t(MONITORING_STRINGS.monitoring),
    };
  }, [t]);

  const capabilityBreadcrumbs = useCapabilityBreadcrumbs();
  const breadcrumbProps: BreadcrumbsProps = {
    currentPageName: labels.heading,
    links: [capabilityBreadcrumbs[0]],
  };
  const breadcrumbs = <Breadcrumbs {...breadcrumbProps} data-id={MONITORING_DATA_IDS.breadcrumbs} />;

  const screenContent = (
    <>
      <MonitoringDashboardContent />
    </>
  );
  return (
    <DxpScreen
      breadcrumbs={breadcrumbs}
      heading={labels.heading}
      hideHeading
      layout={DXP_SCREEN_LAYOUT_STANDARD}
      structure={DXP_SCREEN_STRUCTURE_WIDE}
    >
      {screenContent}
    </DxpScreen>
  );
};
